import authService from "../shared-components/api-authorization/AuthorizeService";

const isBackofficeApiUrl = (requestInfo: RequestInfo | URL) => {
    return (
        requestInfo.toString().startsWith("/api") ||
        requestInfo.toString().startsWith("/health")
    );
};

const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
    const [resource, options] = args;

    if (isBackofficeApiUrl(resource)) {
        const accessToken = await authService.getAccessToken();
        // const language = convertLanguageIdtoModules(i18n.language);

        if (options?.headers) {
            (options.headers as any)["Authorization"] = `Bearer ${accessToken}`;
            // request.headers["x-languageId"] = language.toString();
        }
    }
    return await originalFetch(resource, options);
};
